import React, { Component } from 'react';

import { MediaQueryAPI } from '@philips-emr/tws-components-api';
import { MediaQueries } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, element, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { enumValues, getLostProps, propagateProps } from '@philips-emr/tws-utils';

const acceptedTypes = enumValues(ComponentType);

@AwesomeComponent({ type: ComponentType.BEHAVIOR, api: MediaQueryAPI })
class MediaQuery extends Component {
  state = {
    render: true,
  };

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    query: oneOf(enumValues(MediaQueries)),
    uuid: string,
  };

  static defaultProps = {
    query: MediaQueries.NONE,
  };

  screenTest(event) {
    this.setState({
      render: event.matches,
    });
  }

  bindedScreenTest = this.screenTest.bind(this);

  removeMatchMedia() {
    this.media.removeListener(this.bindedScreenTest);
    delete this.media;
  }

  createMatchMedia() {
    const { query } = this.props;

    if (this.media) {
      this.removeMatchMedia();
    }

    this.media = window.matchMedia(query);
    this.media.addListener(this.bindedScreenTest);

    this.setState({
      render: this.media.matches,
    });
  }

  componentDidMount() {
    this.createMatchMedia();
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props;

    if (query === prevProps.query) {
      return;
    }

    this.createMatchMedia();
  }

  componentWillUnmount() {
    this.removeMatchMedia();
  }

  render() {
    const { render } = this.state;
    const { children, uuid } = this.props;

    if (!render) {
      return null;
    }

    const Container = ContainerProvider.provide(this);
    const lostProps = getLostProps(MediaQuery.propTypes, this.props);

    return (
      <Container acceptedTypes={acceptedTypes} className="c-media-query" uuid={uuid}>
        {propagateProps(children, lostProps)}
      </Container>
    );
  }
}

export default MediaQuery;
